import { Row, Col, Card } from 'react-bootstrap';
import { ArrowDownOutline, ArrowUpOutline } from "react-ionicons";
import './CallVolumeCard.scss';

const CallVolumeCard = ({
    title,
    month,
    priorMonth,
    year,
    priorYear,
    percentagePeriod,
    percentageYTD
}) => {
    return (
        <Card className='my-3 mx-2'>
            <Card.Title className='text-center mt-4 mb-0'>{title}</Card.Title>

            <Card.Body>
                <Row className='justify-content-center align-content-center'>
                    <Col xs={6} className="p-2">
                        <div className="month-bg call-volume-rectangle float-end rounded">
                            <span className="title">This Month</span>
                            <span className="number">{month}</span>
                        </div>
                    </Col>
                    <Col xs={6} className="p-2">
                        <div className="month-bg call-volume-rectangle float-start rounded">
                            <span className="title">This Month - PY</span>
                            <span className="number">{priorMonth}</span>
                        </div>
                    </Col>
                </Row>

                <Row className='justify-content-center align-content-center'>
                    <Col xs={6} className="p-2">
                        <div className="year-bg call-volume-rectangle float-end rounded">
                            <span className="title">Current Year</span>
                            <span className="number">{year}</span>
                        </div>
                    </Col>
                    <Col xs={6} className="p-2">
                        <div className="year-bg call-volume-rectangle float-start rounded">
                            <span className="title">PYTD</span>
                            <span className="number">{priorYear}</span>
                        </div>
                    </Col>
                </Row>

                <Row className='justify-content-center align-content-center'>
                    <Col xs={6} className="p-2">
                        <div className="variance-bg float-end call-volume-rectangle rounded">
                            <span className="title">% Period - CY vs. PY</span>
                            <span className="number">{percentagePeriod}</span>
                        </div>
                    </Col>
                    <Col xs={6} className="p-2">
                        <div className="variance-bg float-start call-volume-rectangle rounded">
                            <span className="title">% YTD - CY vs. PY</span>
                            <span className="number">{percentageYTD}</span>
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}

export default CallVolumeCard;
